module.exports = __webpack_public_path__ + "img/ncs.1960ce7c.png";